"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a;
    return (0, styles_1.createStyles)({
        container: material_kit_pro_react_1.container,
        coloredShadow: material_kit_pro_react_1.coloredShadow,
        centered: {
            display: 'flex',
            justifyContent: 'center'
        },
        earnHeader: {
            marginTop: theme.spacing(4)
        },
        optionImage: {
            height: 145,
            width: 145
        },
        surveyCard: {
            paddingBottom: theme.spacing(4),
            paddingTop: theme.spacing(4)
        },
        surveyInput: {
            outline: 'auto',
            backgroundColor: theme.palette.common.white
        },
        surveyBtn: (_a = {
                width: '40%',
                alignSelf: 'center'
            },
            _a[theme.breakpoints.down('xs')] = {
                marginBottom: theme.spacing(4)
            },
            _a)
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map